import {
  ACRONYMS as ACRONYMS_SIE,
  GLOSSARY as GLOSSARY_SIE,
  FLASHCARDS as FLASHCARDS_SIE,
  QUESTIONS as QUESTIONS_SIE,
} from './sie'

import {
  ACRONYMS as ACRONYMS_SERIES6,
  GLOSSARY as GLOSSARY_SERIES6,
  FLASHCARDS as FLASHCARDS_SERIES6,
  QUESTIONS as QUESTIONS_SERIES6,
} from './series6'

import {
  ACRONYMS as ACRONYMS_SERIES7,
  GLOSSARY as GLOSSARY_SERIES7,
  FLASHCARDS as FLASHCARDS_SERIES7,
  QUESTIONS as QUESTIONS_SERIES7,
} from './series7'

import {
  ACRONYMS as ACRONYMS_SERIES63,
  GLOSSARY as GLOSSARY_SERIES63,
  FLASHCARDS as FLASHCARDS_SERIES63,
  QUESTIONS as QUESTIONS_SERIES63,
} from './series63'

import {
  ACRONYMS as ACRONYMS_SERIES65,
  GLOSSARY as GLOSSARY_SERIES65,
  FLASHCARDS as FLASHCARDS_SERIES65,
  QUESTIONS as QUESTIONS_SERIES65,
} from './series65'

import {
  ACRONYMS as ACRONYMS_SERIES66,
  GLOSSARY as GLOSSARY_SERIES66,
  FLASHCARDS as FLASHCARDS_SERIES66,
  QUESTIONS as QUESTIONS_SERIES66,
} from './series66'

export const BUNDLE_ACRONYMS = {
  'sie': ACRONYMS_SIE,
  'series6': ACRONYMS_SERIES6,
  'series7': ACRONYMS_SERIES7,
  'series63': ACRONYMS_SERIES63,
  'series65': ACRONYMS_SERIES65,
  'series66': ACRONYMS_SERIES66,
}

export const BUNDLE_GLOSSARY = {
  'sie': GLOSSARY_SIE,
  'series6': GLOSSARY_SERIES6,
  'series7': GLOSSARY_SERIES7,
  'series63': GLOSSARY_SERIES63,
  'series65': GLOSSARY_SERIES65,
  'series66': GLOSSARY_SERIES66,
}

export const BUNDLE_FLASHCARDS = {
  'sie': FLASHCARDS_SIE,
  'series6': FLASHCARDS_SERIES6,
  'series7': FLASHCARDS_SERIES7,
  'series63': FLASHCARDS_SERIES63,
  'series65': FLASHCARDS_SERIES65,
  'series66': FLASHCARDS_SERIES66,
}

export const BUNDLE_QUESTIONS = {
  'sie': QUESTIONS_SIE,
  'series6': QUESTIONS_SERIES6,
  'series7': QUESTIONS_SERIES7,
  'series63': QUESTIONS_SERIES63,
  'series65': QUESTIONS_SERIES65,
  'series66': QUESTIONS_SERIES66,
}

// Securities has no articles. Keep the article interface uniform with other brands.
export const LOAD_ARTICLES = async () => []
export const BUNDLE_ARTICLE_COUNTS = {}
